import { Component, input } from '@angular/core';

@Component({
  selector: 'app-blob-loader',
  standalone: true,
  imports: [],
  templateUrl: './blob-loader.component.html',
  styleUrl: './blob-loader.component.scss'
})
export class BlobLoaderComponent {
  width = input<string>('1.25rem');
  height = input<string>('1.25rem');
}
